{
    "mulakatdegerlendirme": {
        "Baslik": "Interview Evaluation",
        "AdSoyad": "Full Name",
        "Telefon": "Phone",
        "Email": "E-mail",
        "Gorusme": "Interview",
        "Not": "Note",
        "KisiBilgisi": "Personal Info",
        "Iletisim": "Communication",
        "Muhakeme": "Reasoning",
        "CalismaAliskanliklari": "Work Habits",
        "Degerlendirme": "Evaluation",
        "DegerlendirmeSonucu": "Evaluation Result",
        "GenelDegerlendirme": "General Evaluation and Views",
        "Soru": "Question",
        "Yanit": "Answer",
        "Puan": "Score",
        "IfadeEtme": "Self Expression",
        "SoruSormaDinleme": "Effective Questioning and Listening",
        "Etkileme": "Influence",
        "NegatifGostergeler": "Negative Indicators",
        "PozitifGostergeler": "Positive Indicators",
        "AdayKayıtEt": "Register Candidate",
        "Gorusme1": "1st Interview",
        "Gorusme2": "2nd Interview",
        "IletisimAciklama": "EVALUATED COMPETENCY: Interpersonal communication (Expression, active listening, effective questioning, summarizing)",
        "MuhakemeAciklama": "EVALUATED COMPETENCY: Reasoning (Analysis and decision making)",
        "CalismaAciklama": "WORK HABITS (Awareness of responsibilities, timely job completion, industriousness)",
        "SoruKai1": "Explain an experience where you successfully changed someone's opinion and guided them in your direction.",
        "SoruKai2": "Explain through an example what methods you use to listen to someone effectively.",
        "SoruMuka1": "Explain how you tried to solve a problem related to your job that challenged you significantly.",
        "SoruMuka2": "Explain an experience where you accurately identified the views and needs of people around you.",
        "SoruCal1": "Explain an experience where you took ownership of a task and completed it successfully on time and in full.",
        "SoruCal2": "Talk about a case where you could not finish your tasks in time.",
        "YanitPlaceholder": "Your answer",
        "PuanAraligi": "Score (1-10)",
        "NegatifIndicator1": "Messages sent are not clear and understandable",
        "NegatifIndicator1_2": "Boring listeners by making unnecessary and long speeches",
        "PositiveIndicator1": "Expresses thoughts clearly and properly, fluent speech",
        "PositiveIndicator1_2": "Use of appropriate body language and voice tone",
        "NegatifIndicator2": "Moving away from focus because of not listening",
        "NegatifIndicator2_2": "Not listening by focusing on what they will say",
        "PositiveIndicator2": "Listening to others, taking their thoughts into account",
        "PositiveIndicator2_2": "Showing active listening (confirming, nodding, summarizing)",
        "NegatifIndicator3": "Failing to find alternative methods when presented with opposite ideas",
        "NegatifIndicator3_2": "Withdrawing and not attempting to persuade when faced with opposing ideas",
        "PositiveIndicator3": "Being moderate and conciliatory, positive approach to events",
        "PositiveIndicator3_2": "Successfully defends own idea by presenting strong reasons against opposing ideas",
        "NegatifIndicatorMuka": "Not being able to see relationships between events",
        "NegatifIndicatorMuka2": "Making decisions with heavy emotional side, lack of rational basis",
        "PositiveIndicatorMuka": "Systematic approach to situation, event and information",
        "PositiveIndicatorMuka2": "Reaching judgments based on logic and facts",
        "NegatifIndicatorCal": "Avoiding self-sacrifice, not owning the job",
        "NegatifIndicatorCal2": "Blaming others for mistakes",
        "PositiveIndicatorCal": "Having work desire and perseverance",
        "PositiveIndicatorCal2": "Seeing self as owner of the task, completes on time"
    },
    "Onceki": "Previous",
    "Sonraki": "Next",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Seciniz": "Select",
    "Olumlu": "Positive",
    "Olumsuz": "Negative",
    "Arama": "Search",
    "Kapat": "Close",
    "Temizle": "Clear",
    "Yenile": "Refresh",
    "YeniEkle": "Add New"
}
